<template>
  <ValidationProvider :rules="rule" v-slot="{ valid, touched }">
    <label :for="id" :id="'label-' + id">
      <span class="label">{{ label }}</span>
      <abbr class="required" title="(required)">*</abbr>
      <em class="error-msg alert" v-if="!valid && touched && type=='email'">Must be a valid email</em>
      <em class="error-msg alert" v-if="!valid && touched && type=='required'">Must be completed</em>
    </label>
    <small class="hint" v-if="hint" v-html="hint"></small>
    <input
      :id="id"
      :vid="id"
      v-model="field"
      :name="name"
      :type="type"
      :maxlength="maxlength"
      :size="size"
      :max="max"
      :placeholder="placeholder"
      :class="{'error-input': !valid && touched, 'stretchWidth': type != 'date' && size == 100 }"
    />
  </ValidationProvider>
</template>
<style>
  .error-input {
    border-color: #f85c50 !important;
    color: #f85c50
  }
  .error-msg {
    color: #d93d31;
    font-weight: 700;
  }
</style>
<script>
export default {
  props: {
    value: String,
    id: String,
    name: String,
    hint: String,
    label: String,
    max: String,
    placeholder: String,
    required: String,
    type: {
      type: String,
      default: "text"
    },
    maxlength: {
      type: String,
    },
    size: { 
      type: String,
      default: "100"
    }
  },
  computed: {
    field: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    }, 
    rule: {
      get() {
        switch (this.type) {
          case "email": 
            return `email:#label-${this.id}`
          default: 
            return `required:#label-${this.id}`
        }
      }
    }
  }
}
</script>